import {
    Box,
    Stack,
    Text,
    ThemeColorVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import Price from "components/price";
import { useActivityPrices } from "hooks/use-activity-prices";
import { useTranslation } from "react-i18next";
import { PaymentEventType } from "types/payment";
import { isWaitList } from "utils/booking";
import { BookingSummaryItem } from "./booking-summary-list-item";

const PaymentInformation = () => {
    const { t } = useTranslation();
    const { data: webBooking } = useWebBooking();
    const { totalPrice } = useActivityPrices();

    if (!webBooking) {
        return null;
    }

    const isWaitListBooking = isWaitList(webBooking);
    const charge = webBooking.paymentEvents?.findLast(
        (x) =>
            x.type === PaymentEventType.WebBookingCharge ||
            x.type === PaymentEventType.PaymentLinkCharge
    );
    const formattedTransactionDate = charge?.transactionDate?.format("YYYY-MM-DD HH:mm");

    const isPartialPayment = totalPrice > 0 && webBooking.chargePayedAmount < totalPrice;

    return (
        <Box>
            <Text fontWeight="medium">{t("payment.prePayment")}</Text>
            <Stack spacing={ThemeSpaceVariable.XSmall} mt={ThemeSpaceVariable.Small}>
                <BookingSummaryItem
                    label={t(isPartialPayment ? "payment.payedPart" : "payment.payed")}
                >
                    <Price
                        amount={webBooking.chargePayedAmount}
                        display="symbol"
                        color={ThemeColorVariable.OnSurfaceSubdued}
                    />
                </BookingSummaryItem>
                {!isWaitListBooking && (
                    <BookingSummaryItem label="" value={formattedTransactionDate} />
                )}
            </Stack>
        </Box>
    );
};

export default PaymentInformation;
